import api from '@/services/api'

export default class EvaluationQuestionSection {
  // THIS DOES NOT EXIST YET
  static EVALUATION_QUESTION_SECTION_ENDPOINT = 'evaluation-question-section'
  /**
   * Initialize a `EvaluationQuestionSection` instance.
   *
   * @param {class} cls  The class to use to create evaluationResponse objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EvaluationQuestionSection`.
   *
   * @param {class} cls      The class to use to create evaluationResponse objects.
   **/
  static create(cls) {
    return new EvaluationQuestionSection(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one evaluationResponse from the API.
   *
   * @param {String} evaluationQuestionSectionId  Unique ID of the evaluation to retrieve.
   */
  get(evaluationQuestionSectionId) {
    const url = `${
      EvaluationQuestionSection.EVALUATION_QUESTION_SECTION_ENDPOINT
    }/${evaluationQuestionSectionId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all evaluationResponse through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${EvaluationQuestionSection.EVALUATION_QUESTION_SECTION_ENDPOINT}/`
    const options = {
      params: {},
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a evaluationResponse through the API.
   *
   * @param {evaluationQuestion} evaluationQuestion data to send to the API.
   */
  update(evaluationQuestionSection, fields = [], excludeFields = []) {
    const url = `${EvaluationQuestionSection.EVALUATION_QUESTION_SECTION_ENDPOINT}/${
      evaluationQuestionSection.id
    }/`
    const data = this.cls.toAPI(evaluationQuestionSection, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
